(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rsg-editorial-article"] && !Shopify.designMode) return;
  try {
    
  function initialiseRsgEditorialArticle(articleRoot) {
    if (!articleRoot || articleRoot.dataset.rsgEditorialArticleReady === 'true') return;
    var body = articleRoot.querySelector('[data-rsg-editorial-article-body]');
    var aside = articleRoot.querySelector('[data-rsg-editorial-article-aside]');
    var toc = articleRoot.querySelector('[data-rsg-editorial-article-toc]');
    var list = toc && toc.querySelector('ol');
    if (!body || !aside || !toc || !list) return;

    var usedIds = {};
    var headings = Array.prototype.slice.call(body.querySelectorAll('h2:not([data-rsg-toc-ignore])'));
    headings.forEach(function (heading, index) {
      var baseId = heading.id || heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'article-section-' + (index + 1);
      var uniqueId = baseId;
      var suffix = 2;
      while (usedIds[uniqueId]) {
        uniqueId = baseId + '-' + suffix;
        suffix += 1;
      }
      usedIds[uniqueId] = true;
      heading.id = uniqueId;

      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + uniqueId;
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      list.appendChild(item);
    });

    if (headings.length < 2) aside.hidden = true;
    if (window.matchMedia('(max-width: 749px)').matches) toc.open = false;
    articleRoot.dataset.rsgEditorialArticleReady = 'true';
  }

  document.querySelectorAll('[data-rsg-editorial-article]').forEach(initialiseRsgEditorialArticle);
  document.addEventListener('shopify:section:load', function (event) {
    var articleRoot = event.target.matches('[data-rsg-editorial-article]')
      ? event.target
      : event.target.querySelector('[data-rsg-editorial-article]');
    initialiseRsgEditorialArticle(articleRoot);
  });

  } catch(e) { console.error(e); }
})();
})();
